import * as actions from 'actions/labels';

const initialState = {
  error: null,
  loading: false,
  items: [],
  item: null,
};

const labelReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_LABELS: {
      return { ...state, loading: true };
    }
    case actions.FETCHED_LABELS: {
      return {
        ...state,
        items: action.payload.labels.filter(i => i.name !== ''),
        loading: false,
      };
    }
    case actions.FETCH_LABELS_ERROR: {
      return { ...state, error: action.payload.error };
    }

    case actions.FETCH_LABEL: {
      return { ...state, loading: true };
    }
    case actions.FETCHED_LABEL: {
      return { ...state, item: action.payload.item, loading: false };
    }
    case actions.FETCH_LABEL_ERROR: {
      return { ...state, error: action.payload.error, loading: false };
    }

    case actions.CREATE_LABEL: {
      return { ...state, loading: true };
    }
    case actions.CREATED_LABEL: {
      return { ...state, item: action.payload.item, loading: false };
    }
    case actions.CREATE_LABEL_ERROR: {
      return { ...state, error: action.payload.error, loading: false };
    }

    default: {
      return state;
    }
  }
};

export default labelReducer;



// WEBPACK FOOTER //
// ./src/reducers/labels/index.js